export function checkLength(title, number, inAll) {
  if (title?.length > number) {
    var newTitle = title.slice(0, number);
    return newTitle + " ...";
  } else {
    return title;
  }
}

export default checkLength;
